export default __webpack_public_path__ + "static/human-capital-9662521d12d6e4b6e75926f2db5e5d18.webp";